import styled, { css } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  min-width: 720px;
`;

const FullWidthContentContainer = styled(ContentContainer)`
  width: 95%;

  & > .loading-panel-loaded {
    display: none;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  border-top: 1px solid ${props => props.theme.secondaryColorLight};
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  padding: 16px 0;

  &:hover {
    background-color: ${props => props.theme.secondaryColorLight};
  }
`;

const HeaderMixin = css`
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
`;

const Column = styled.div`
  font-size: 19px;
  padding-left: 8px;
`;

const Link = styled.a`
  margin: 0 8px;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 64px 0 0 32px;
`;

const ActionTitle = styled.label`
  font-size: 16px;
  margin-bottom: 16px;
`;

const ActionLink = styled.a`
  color: #577086;

  &:hover {
    color: ${props => props.theme.secondaryColor};
  }
`;

export {
  ActionContainer,
  ActionLink,
  ActionTitle,
  Column,
  Container,
  ContentContainer,
  FullWidthContentContainer,
  HeaderContainer,
  HeaderMixin,
  Link,
  RowContainer,
};
